import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

export const Info = styled.div`
    color: ${({ theme }) => theme.bsText7};
    width: 432px;
    height: 280px;
    overflow-y: scroll;
    padding: 16px 30px;
    border-radius: 20px;
    background: ${({ theme }) => theme.bsBg2};
    ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
    `};
`


export default function Barking () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/barking.png'}/>
        <RowColumn>
          <ExchangeNft type={NFTTYPE.BARKING} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>How do Barking Sound NFTs work?</Text>
            <Text fontSize={14} marginTop={20}>1. Barking NFTs are 10,000 unique barking sounds, each with a cartoon dog barking animation video, which are created by a top artist from Bakery’s NFT art community. These unique NFTs are a first-timer in the NFT field, which now come to build the meme 3.0 world and add value to the Crypto Doggies’ ecosystem. </Text>
            <Text fontSize={14} marginTop={20}>2. The Barking NFT can only be purchased with $Bark in Bakeryswap.org Gamification tab (The Barking Shop) for 500,000 $BARK, or from another holder at the NFT Marketplace (as a secondary market, where the price is decided by the owner). The NFT marketplace will only support $BARK payment.</Text>
            <Text fontSize={14} marginTop={20}>3. All the 500,000 $BARK spent in the Barking Shop will be burned. $BARK has a total supply of 10 billion coins. Besides the collectible value of Barking Sound NFT, holders of the NFT will also benefit from other key ecosystem features, like gaming.</Text>
            <Text fontSize={14} marginTop={20}>4. What would make Barking Sound more special in the future, is that there will be a minor cost in $BARK to play them (at the begining this action will be free). We plan to donate 80% of this cost to animal care organizations, while the remaining 20% will be burned.</Text>
          </Info>
        </RowColumn>
      </Main>
    </SoccerMain>
  )
}